export default {
  GAME_UPDATE: 'game_update',
  GAME_JUMP_FOREPLAY: 'game_jump_foreplay',
  GAME_CHANGE_FOREPLAY_INDEX: 'game_change_foreplay_index',
  JOIN_GAME_SUCCESS: 'join_game_success',
  JOIN_GAME_FAILURE: 'join_game_failure',
  REFRESH_GAME: 'refresh_game',
  REFRESH_GAME_STATS: 'refresh_game_stats',
  REFRESH_FOREPLAY_STATS: 'refresh_foreplay_stats',
  GAME_UPDATE_SHOW_RESULTS: 'game_update_show_results',
  GAME_UPDATE_SHOW_FOREPLAY_RESULTS: 'game_update_show_foreplay_results',
  GAME_CLEAN_STATE: 'game_clean_state',
  GAME_ENABLE_FOREPLAY: 'game_enable_foreplay',
  GAME_ENABLE_GAME: 'game_enable_game',
  GAME_DISABLE_FOREPLAY: 'game_disable_foreplay',
  GAME_CHANGE_REVEALED_FLAG: 'game_change_revealed_flag',
  REFRESH_GAME_ANSWER_STATS: 'refresh_game_answer_stats',
  GAME_ON_ANSWER_STATS_RESET: 'game_on_answer_stats_reset',
  REFRESH_PLAYER_LIST: 'refresh_player_list',
  GAME_UPDATE_LOG: 'game_update_log',
}



// WEBPACK FOOTER //
// ./src/entities/game/types.js